export default __webpack_public_path__ + "static/media/Biology_01_07.8e30f4c2.png";